import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  Typography,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import RichTextEditorDialog from "./RichTextEditor";
import { get, put } from "src/utils/networkUtils";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

export default function DefaultDetailDialog({ open, handleClose }) {
  const [prizeDrawBody, setPrizeDrawBody] = useState({
    postalEntry: "",
    tAndCs: "",
    winnersMessage: "",
  });
  const postalEntryRef = useRef(null);
  const tAndCsRef = useRef(null);
  const winnersMsgRef = useRef(null);
  const [value, setValue] = useState(0);

  useEffect(() => {
    get(`/admin/prize-draws-details`).then(function (response) {
      setPrizeDrawBody(response.prizeDrawDetails);
    });
  }, []);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const handleSubmitPrizeDrawDetils = async () => {
    const body = {
      postalEntryText: prizeDrawBody.postalEntry,
      termsAndConditionsText: prizeDrawBody.tAndCs,
      winnerMessageText: prizeDrawBody.winnersMessage,
    };
    const resp = await put(`/admin/prize-draws-details`, body);
    if (resp.success) {
      handleClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ borderRadius: 3 }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" fontWeight="bold">
            Default Details
          </Typography>
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmitPrizeDrawDetils}
              variant="contained"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </DialogTitle>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
        >
          <Tab label="Postal Entry" {...a11yProps(0)} />
          <Tab label="T&Cs" {...a11yProps(1)} />
          <Tab label="Inbox Winners Message" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <Grid item xs={12} sx={{ mt: 4 }}>
          <RichTextEditorDialog
            editorRef={postalEntryRef}
            value={prizeDrawBody.postalEntry}
            onChange={(html) =>
              setPrizeDrawBody((prev) => ({ ...prev, postalEntry: html }))
            }
            fieldName="postalEntry"
          />
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid item xs={12} sx={{ mt: 4 }}>
          <RichTextEditorDialog
            editorRef={tAndCsRef}
            value={prizeDrawBody.tAndCs}
            onChange={(html) =>
              setPrizeDrawBody((prev) => ({ ...prev, tAndCs: html }))
            }
            fieldName="tAndCs"
          />
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Grid item xs={12} sx={{ mt: 4 }}>
          <RichTextEditorDialog
            editorRef={winnersMsgRef}
            value={prizeDrawBody.winnersMessage}
            onChange={(html) =>
              setPrizeDrawBody((prev) => ({ ...prev, winnersMessage: html }))
            }
            fieldName="winnersMessage"
          />
        </Grid>
      </TabPanel>
    </Dialog>
  );
}
